const mobileApp = {
  ScanDownload: 'Scan for download now',
  IntroductionTitle: 'Introduction',
  Introduction1:
    'UTraffic is an application provides real-time traffic information of different areas in Ho Chi Minh city. It is developed by a group of students and master’s students from University of Technology Ho Chi Minh city under supervision of Associate Professor Tran Minh Quang.',
  Introduction2:
    'After phases of research and development, the main functionalities of the application (details in section “II. Features”) have been completed and ready to publish as an experiment. Main purpose of this experiment is to encourage people contributing their data to improve traffic data quantity and quality as well as practice business model of rewarding user based on their contributed data.',
  Introduction3:
    'Currently UTraffic only supports Android, other platforms will be supported in future.',
  FeaturesTitle: 'Features',
  Feature1:
    'Traffic status: user can view real-time traffic of different areas in Ho Chi Minh city in level of service represented in below scale:',
  TrafficStatus1: 'Green: free flow.',
  TrafficStatus2: 'Light yellow: reasonably free flow.',
  TrafficStatus3: 'Dark yellow: stable flow.',
  TrafficStatus4: 'Orange: unstable flow.',
  TrafficStatus5: 'Red: forced or breakdown flow.',
  Feature2:
    'Traffic routing: based on traffic status at the time user requests, UTraffic calculates best routes to reach destination by shortest time or shortest distance.',
  Feature3:
    'Traffic data contributing: when using UTraffic, user provides their own GPS data to system, this data is combined with data collected from other sources to calculate transportation level of service. In addition, user can also provide photo and detailed description about any events happen on the way so system administrator and other users can flexibly adjust their plan.',
  Reward: 'Reward:',
  Feature4:
    'for each kilometer of moving with UTraffic installed and location service enabled, user receives 1 point and 300 points equal to 10.000 VND mobile top-up card. To redeem, user makes a redemption request on UTraffic to get code for top-up.',
  ManualTitle: 'User Manual',
  ViewNow: 'View Now',
  SupportTitle: 'Support',
  Support1:
    'UTraffic is still in development so issues can’t be avoided. If you find any unexpected behaviors, please send email to',
  Support2:
    'or send message to skype nguyentantrungs or contact mobile number 0933 773 068, we will check and fix.',
  ThankYou: 'Your participation and support are highly appreciated! ',
  InstallApp1:
    'To install UTraffic, look for application with keyword "Cảnh Báo TTGT" on Play Store or access direct link',
  InstallApp2:
    'or scan QR code of top corner of this manual then install the application and allow location service to be used.',
  Login:
    'Once finish installation and open application, below screen is shown.',
  Register:
    'To register, click “Đăng ký”, input Name (Họ Tên), Username (Tên đăng nhập), Password (Mật khẩu), Confirm password (Xác nhận mật khẩu), Mobile phone (Số điện thoại) and Email (Địa chỉ email) then click "Đăng Ký". If already registered, please proceed to step 4.',
  MainScreen: 'Login with registered credential. Main interface of the application is as following:',
  TrafficStatusInfo: 'To turn on/off information about traffic status on the map, user can click',  
  Search: 'To see traffic at some area, zoom and drag on the map or use search bar to quickly navigate to that place.',
  Menu: 'UTraffic automatically collects GPS data and calculates reward point when user starts moving. To see this point, click on “Tài khoản” at bottom left corner then select “Quản lý voucher”.',
  RewardDisplay: 'Reward point is displayed at top right corner of the screen. 1 point equals to 1 km.',
  ChangePoint1: 'To exchange point for top-up card, user clicks',
  ChangePoint2: '. There are top-up cards for different network providers.',
  SelectCard: 'Select top-up card then click',
  Payment: 'Check information and click',
  ViewVoucher1: 'Top-up card code can be found on tab',
  ViewVoucher2: 'click this button',
  ViewVoucher3: 'on top left corner and select',
  ViewCode: 'Click to select the redemption voucher to see the card code',
  CheckVersion: 'To check current installed version or leave feedback, click ',
};

export default mobileApp;
